/* RESPONSIBLE TEAM: team-inbox */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import { type CustomActionFinishedWireFormat } from 'embercom/objects/inbox/result-summary';
import CustomBotSummary from '../custom-bot-summary';

export default class CustomActionFinished implements RenderableData {
  renderableType: RenderableType = RenderableType.CustomActionFinished;
  readonly customActionName: string;
  readonly customActionResult: string;
  readonly usedSampleResponseData: boolean;
  readonly customBotSummary?: CustomBotSummary;
  readonly customActionId?: number;
  readonly latencyMs?: number;
  readonly responsePayloadSizeBytes?: number;
  readonly actionExecutionResultId?: number;
  readonly httpStatus?: number;
  readonly errorMessage?: string;

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  constructor(
    customActionName: string,
    result: string,
    usedSampleResponseData: boolean,
    customBotSummary?: CustomBotSummary,
    customActionId?: number,
    latencyMs?: number,
    responsePayloadSizeBytes?: number,
    actionExecutionResultId?: number,
    httpStatus?: number,
    errorMessage?: string,
  ) {
    this.customActionName = customActionName;
    this.customActionResult = result;
    this.usedSampleResponseData = usedSampleResponseData;
    this.customBotSummary = customBotSummary;
    this.customActionId = customActionId;
    this.latencyMs = latencyMs;
    this.responsePayloadSizeBytes = responsePayloadSizeBytes;
    this.actionExecutionResultId = actionExecutionResultId;
    this.httpStatus = httpStatus;
    this.errorMessage = errorMessage;
  }

  static deserialize(json: CustomActionFinishedWireFormat): CustomActionFinished {
    return new CustomActionFinished(
      json.custom_action_name,
      json.custom_action_result,
      json.used_sample_response_data,
      json.custom_bot_summary ? CustomBotSummary.deserialize(json.custom_bot_summary) : undefined,
      json.custom_action_id,
      json.latency_ms,
      json.response_payload_size_bytes,
      json.action_execution_result_id,
      json.http_status,
      json.error_message,
    );
  }
}
